// EN-8899
export const SPLIT_IO_FEATURE_FLAG_OPEN_FILTERS_ON_CLP = 'FeatureFlag-EN8899-Open_Filters_on_Photobook_CLP_Desktop-AB_test_';
export const SPLIT_IO_FEATURE_FLAG_OPEN_FILTERS_ON_CLP_COOKIE = 'au_split_feature_flag_open_filters_on_clp';
// EN-9522
export const SPLIT_IO_FEATURE_FLAG_CART_PREVIEW_1 = 'FeatureFlag-EN9522-_Cart_preview_AB_test_-_Iteration_1';
export const SPLIT_IO_FEATURE_FLAG_CART_PREVIEW_1_COOKIE = 'au_split_feature_flag_cart_preview_1';
// EN-9882
export const SPLIT_IO_FEATURE_FLAG_CART_PRICE_TRANSPARENCY =
  'FeatureFlag-EN-9882-Price-Transparency_incartandcheckout-ABTest';
export const SPLIT_IO_FEATURE_FLAG_CART_PRICE_TRANSPARENCY_COOKIE = 'au_split_feature_flag_price_transparency_ab_test';
// EN-10100
export const SPLIT_IO_FEATURE_FLAG_PRODUCT_ASSISTANT = 'FeatureFlag-EN10100-Product-Assistant';
export const SPLIT_IO_FEATURE_FLAG_PRODUCT_ASSISTANT_COOKIE = 'au_split_feature_flag_product_assistant';
// EN-8897/10325
export const SPLIT_IO_FEATURE_FLAG_SHIPPING_TEST = 'FeatureFlag-EN-10325-Shipping-Test2';
export const SPLIT_IO_FEATURE_FLAG_SHIPPING_TEST_COOKIE = 'au_split_feature_flag_shipping_test';
// EN-10162
export const SPLIT_IO_FEATURE_FLAG_OPTION_PRICING = 'Featureflag-EN10162-PDP-Option-Pricing';
export const SPLIT_IO_FEATURE_FLAG_OPTION_PRICING_COOKIE = 'au_split_feature_flag_pdp_option_pricing';
// EN-10484
export const SPLIT_IO_FEATURE_FLAG_PDP_ENGAGING_IMAGES = 'FeatureFlag-EN10484-PDP-Engaging-Images';
export const SPLIT_IO_FEATURE_FLAG_PDP_ENGAGING_IMAGES_COOKIE = 'au_split_feature_flag_pdp_engaging_images';
// EN-10227
export const SPLIT_IO_FEATURE_FLAG_MOVE_LOGIN_GATE = 'FeatureFlag-EN10227-Move-Login-Gate';
export const SPLIT_IO_FEATURE_FLAG_MOVE_LOGIN_GATE_COOKIE = 'au_split_feature_flag_move_login_gate';
// EN-10230
export const SPLIT_IO_FEATURE_FLAG_PAGE_PRICING = 'FeatureFlag-EN-10230-Page-Pricing-ABTest';
export const SPLIT_IO_FEATURE_FLAG_PAGE_PRICING_COOKIE = 'au_split_feature_flag_page_pricing_ab_test';
// EN-10161
export const SPLIT_IO_FEATURE_FLAG_EXPLORE_SIMILAR_PRODUCTS = 'FeatureFlag-EN10161-Explore-Similar-Products';
export const SPLIT_IO_FEATURE_FLAG_EXPLORE_SIMILAR_PRODUCTS_COOKIE = 'au_split_feature_flag_explore_similar_products';
// EN-10453
export const SPLIT_IO_FEATURE_FLAG_IMAGE_CAROUSEL = 'FeatureFlag-EN10453-ImageCarousel';
export const SPLIT_IO_FEATURE_FLAG_IMAGE_CAROUSEL_COOKIE = 'au_split_feature_flag_image_carousel';
//EN-10444
export const SPLIT_IO_FEATURE_FLAG_AUTO_APPLY_PROMO = 'FeatureFlag-EN10444-AutoApplyPromo';
export const SPLIT_IO_FEATURE_FLAG_AUTO_APPLY_PROMO_COOKIE = 'au_split_feature_auto_apply_promo';
// EN-10776
export const SPLIT_IO_FEATURE_FLAG_DESIGN_IT_FOR_ME = 'FeatureFlag-10776-DesignItForMe';
export const SPLIT_IO_FEATURE_FLAG_DESIGN_IT_FOR_ME_COOKIE = 'au_split_feature_flag_design_it_for_me';
// EN-11034
export const SPLIT_IO_FEATURE_FLAG_MOBILE_PDP_TESTS = 'FeatureFlag-EN11034-PDP_Mobile_Tests';
export const SPLIT_IO_FEATURE_FLAG_MOBILE_PDP_TESTS_COOKIE = 'au_split_feature_flag_mobile_pdp_tests';
